export default class AttachmentContainerComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.configurar();
    }

    configurar() {
        this.copyButton = this.querySelector("button[data-action='copiar-liga']");
        this.linkArea = this.querySelector("textarea[data-action='contener-liga']");
        this.placeholder = this.querySelector("[data-action='placeholder']");
        this.notice = this.querySelector("p");
        this.linkArea.tabIndex = -1;

        this.copyLink = this.copyButtonClickCallback();
        
        this.copyButton.addEventListener("click", this.copyLink);
        this.linkArea.addEventListener("click", this.copyLink);
    }

    copyButtonClickCallback() {
        return () => {
            if (this.linkArea.disabled) {
                return true;
            }

            if (window.isSecureContext) {
                navigator.clipboard.writeText(this.linkArea.value).then(() => {
                    this.linkArea.disabled = true;
                    this.copyButton.disabled = true;
                    this.notice.hidden = false;
                    setTimeout(() => {
                        this.linkArea.disabled = false;
                        this.copyButton.disabled = false;
                        this.notice.hidden = true;
                    }, 4000);
                });
            } else {
                alert("No se puede copiar. Contexto inseguro.");
            }
        }
    }
}
